import {
  Container as RawContainer,
  size,
  mediaQueries,
  colors,
  Button,
  Col,
  Row,
  H3,
} from '@everlywell/leaves';
import SectionWrapper from 'components/SectionWrapper';
import styled from 'styled-components';

interface WrapperProps {
  backgroundColor?: 'Primary' | 'Secondary';
}

export const Wrapper = styled(SectionWrapper)<WrapperProps>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor === 'Primary' ? colors.white : colors.teal1};
`;

export const Container = styled(RawContainer)``;

export const StyledRow = styled(Row)``;

export const StyledCol = styled(Col)`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const ContentSection = styled.div`
  ${mediaQueries.forTabletHorizontalUp} {
    padding-left: ${size.xl2}px;
  }
`;

export const Title = styled(H3)`
  display: inline-block;
  margin-top: ${size.sm}px;
  width: 100%;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: 0;
  }
`;

export const CTA = styled(Button)`
  margin-top: ${size.md}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: ${size.xl1}px;
  }
`;
